import { Segment, Grid, Icon, Divider, Header, Table, Loader } from 'semantic-ui-react';

function MalVerify({ malVerifyData, loading }) {
    return (
        <Segment raised style={{ maxWidth: "500px", margin: "auto", padding: "25px", borderRadius: "12px", backgroundColor: "#fff" }}>
            {loading ? (
                <Loader active inline="centered" size="large" />
            ) : (
                <>
                    {/* Document Preview */}
                    <Grid textAlign="center">
                        {/* <Grid.Row>
                            <Image
                                src={data?.documentImage || "https://react.semantic-ui.com/images/wireframe/image.png"}
                                width={200}
                                height={200}
                                centered
                                style={{
                                    border: "2px solid #ddd",
                                    padding: "5px",
                                    backgroundColor: "#f9f9f9",
                                    objectFit: "cover",
                                    display: "block",
                                    borderRadius: "10px"
                                }}
                            />
                        </Grid.Row> */}

                        {/* Success Message */}
                        <Grid.Row>
                            {/* <Header as="h2" style={{ marginTop: "10px", color: "#C8102E", fontWeight: "bold" }}>
                                <Icon name="check circle" color="red" />
                                Verified Authorization Letter
                            </Header> */}

                            <Header as="h2" style={{ marginTop: '10px', color: '#333', fontWeight: 'bold' }}>
                                <Icon name="check circle" color="green" />
                                Verified 
                            </Header>
                            <p style={{ fontSize: "14px", color: "#666", marginTop: "5px" }}>
                                This is a <strong style={{ color: "#C8102E" }}>genuine Manufacturer’s Authorization Letter</strong>.
                            </p>
                        </Grid.Row>
                    </Grid>

                    <Divider style={{ borderTop: "2px solid #C8102E" }} />

                    {/* Authorization Letter Details */}
                    <Segment basic>
                        <Table celled padded style={{ border: "1px solid #ddd", backgroundColor: "#f9f9f9" }}>
                            <Table.Body>
                                <Table.Row>
                                    <Table.Cell textAlign="center" style={{ backgroundColor: "#fff" }}>
                                        <Icon name="file alternate" size="large" color="red" />
                                    </Table.Cell>
                                    <Table.Cell>
                                        <strong style={{ color: "#C8102E" }}>Tender Name</strong>
                                        <br />
                                        {malVerifyData?.tenderName || "N/A"}
                                    </Table.Cell>
                                </Table.Row>

                                <Table.Row>
                                    <Table.Cell textAlign="center" style={{ backgroundColor: "#fff" }}>
                                        <Icon name="hashtag" size="large" color="red" />
                                    </Table.Cell>
                                    <Table.Cell>
                                        <strong style={{ color: "#C8102E" }}>Tender Reference Number</strong>
                                        <br />
                                        {malVerifyData?.tenderRefNo || "N/A"}
                                    </Table.Cell>
                                </Table.Row>

                                <Table.Row>
                                    <Table.Cell textAlign="center" style={{ backgroundColor: "#fff" }}>
                                        <Icon name="building" size="large" color="red" />
                                    </Table.Cell>
                                    <Table.Cell>
                                        <strong style={{ color: "#C8102E" }}>Partner Company</strong>
                                        <br />
                                        {malVerifyData?.partnerCompany?.companyName || "N/A"}
                                    </Table.Cell>
                                </Table.Row>

                             
                            </Table.Body>
                        </Table>
                    </Segment>
                </>
            )}
        </Segment>
    );
}

export default MalVerify;